import request from '@utils/request'
import axios from 'axios'

export const state = {
  currentMember: getSavedState('auth.currentMember'),
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentMember = newValue;
    saveState('auth.currentMember', newValue);
    setDefaultAuthHeaders(state);
  },
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentMember
  },
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state }) {
    setDefaultAuthHeaders(state)
    // dispatch('validate')
  },

  getCode({ commit, dispatch, getters }, { phoneCode, phoneNumber } = {}) {
    return request
      .post('/merchant/member/getCode', {
        phoneCode,
        phoneNumber
      })
  },

  storeMember({ commit, dispatch, getters }, { email, fullName, gender } = {}) {
    return request
      .post('/merchant/member/store', {
        email,
        fullName,
        gender
      }, { errorHandle: true })
      .then((response) => {
        const member = {
          ...state.currentMember,
          email,
          fullName,
          gender
        };

        commit('SET_CURRENT_USER', member);
      });
  },

  setCurrentUser({ commit, dispatch, getters }, user) {
    commit('SET_CURRENT_USER', user);
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { phoneCode, phoneNumber, verificationCode, lineLinkToken, merchantAlias } = {}) {

    if (getters.loggedIn) return dispatch('validate');

    return request
      .post('/merchant/member/login', {
        phoneCode,
        phoneNumber,
        verificationCode,
        lineLinkToken,
        merchantAlias
      }, { errorHandle: false })
      .then((response) => {
        const member = response.items;
        commit('SET_CURRENT_USER', member);

        if(response.items.lineAccountLinkRedirectUrl) {
          window.location.href = response.items.lineAccountLinkRedirectUrl;
        }else {
          return member
        }

      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
  },

  // line login
  lineLogIn({ commit, dispatch, getters }, { lineLinkToken, merchantAlias } = {}) {
    return request
      .post('/merchant/member/lineaccountlink', {
        lineLinkToken,
        merchantAlias
      }, { errorHandle: false })
      .then((response) => {
        const member = response.items;

        if(response.items.lineAccountLinkRedirectUrl) {
          window.location.href = response.items.lineAccountLinkRedirectUrl;
        }else {
          return member
        }
      })
      .catch((error) => {
        console.log('TCL: lineLogIn -> error', error);
        alert('無法綁定！');

        window.location.href = '/login'
      })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.currentMember) return Promise.resolve(null);

    return request
      .get('/merchant/member/login')
      .then((response) => {
        const user = response.items;
        commit('SET_CURRENT_USER', user);
        return user
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          commit('SET_CURRENT_USER', null)
        }
        return null
      })
  },
};

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentMember
    ? `Bearer ${state.currentMember.token}`
    : ''
}




